var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentRatingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82918 15.9395L3.4195 16.0468L3.46676 15.7869L3.30694 15.5765L2.82918 15.9395ZM2.31164 18.786L2.90197 18.8933V18.8933L2.31164 18.786ZM3.63726 19.9046L3.8423 20.4685L3.63726 19.9046ZM6.58919 18.8312L6.81672 18.276L6.60211 18.1881L6.38414 18.2673L6.58919 18.8312ZM18.4 10.5C18.4 15.1392 14.6392 18.9 10 18.9V20.1C15.3019 20.1 19.6 15.8019 19.6 10.5H18.4ZM10 2.1C14.6392 2.1 18.4 5.86081 18.4 10.5H19.6C19.6 5.19807 15.3019 0.9 10 0.9V2.1ZM1.6 10.5C1.6 5.86081 5.36081 2.1 10 2.1V0.9C4.69807 0.9 0.4 5.19807 0.4 10.5H1.6ZM3.30694 15.5765C2.2356 14.1664 1.6 12.4083 1.6 10.5H0.4C0.4 12.6795 1.12699 14.6908 2.35142 16.3025L3.30694 15.5765ZM2.90197 18.8933L3.4195 16.0468L2.23886 15.8322L1.72132 18.6786L2.90197 18.8933ZM3.43221 19.3408C3.14199 19.4463 2.84672 19.1971 2.90197 18.8933L1.72132 18.6786C1.50035 19.894 2.68142 20.8907 3.8423 20.4685L3.43221 19.3408ZM6.38414 18.2673L3.43221 19.3408L3.8423 20.4685L6.79423 19.3951L6.38414 18.2673ZM10 18.9C8.87218 18.9 7.79769 18.6781 6.81672 18.276L6.36165 19.3864C7.48454 19.8466 8.71343 20.1 10 20.1V18.9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8.5H13",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H10",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentRatingsIcon);
export default __webpack_public_path__ + "static/media/recentRatingsIcon.90ad09894fd56a32627da2793e02fb2c.svg";
export { ForwardRef as ReactComponent };